import { useQuery } from '@tanstack/react-query';

import tagRepository from '@/features/tags/repositories/TagRepository';
import { tagKeys } from '@/shared/query/queryKeys';

export function useTagsQuery() {
  return useQuery({
    queryKey: tagKeys.list(),
    queryFn: () => tagRepository.getTags(),
  });
}
